<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">{{ config.data?.headerTitle ?? "Send Scheduled Notification To All Contractors" }}</span>
      @if (config.data?.selectedNotification) {
        <app-tag
          class="ride-status-tag-sm"
          styleClass="bold"
          [content]="config.data.selectedNotification.Status.title"
          sizeClass="tag-sm"
          [severityClass]="config.data.selectedNotification.Status.severity">
        </app-tag>
      }
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-xl flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    [formGroup]="notificationForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="title"
        >Notification Title <span class="feedback-danger-fg-color">*</span></label
      >
      <input
        id="title"
        formControlName="title"
        type="text"
        placeholder="Enter Notification Title"
        pInputText
        class="w-full" />
      @if (notificationForm.get("title")?.invalid && notificationForm.get("title")?.touched) {
        <small class="p-error">Notification title is required </small>
      }
    </div>

    <div class="form-group w-full">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="body"
        >Notification Body <span class="feedback-danger-fg-color">*</span></label
      >
      <textarea
        rows="5"
        cols="30"
        id="body"
        formControlName="body"
        pTextarea
        [autoResize]="true"
        placeholder="Write your message here"
        class="w-full">
      </textarea>
      @if (notificationForm.get("body")?.invalid && notificationForm.get("body")?.touched) {
        <small class="p-error">Message is required </small>
      }
    </div>

    <div class="grid">
      <div class="form-group col-6">
        <label
          class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
          for="dueDate"
          >Schedule Date <span class="feedback-danger-fg-color">*</span></label
        >
        <p-datepicker
          appendTo="body"
          formControlName="dueDate"
          id="dueDate"
          placeholder="Select Date"
          [iconDisplay]="'input'"
          [showIcon]="true"
          [minDate]="minDate"
          class="w-full">
        </p-datepicker>
        @if (notificationForm.get("dueDate")?.invalid && notificationForm.get("dueDate")?.touched) {
          <small class="p-error">Schedule date is required </small>
        }
      </div>
      <div class="form-group col-6">
        <label
          class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
          for="dueTime"
          >Schedule Time <span class="feedback-danger-fg-color">*</span></label
        >
        <p-datepicker
          appendTo="body"
          formControlName="dueTime"
          id="dueTime"
          placeholder="Select Time"
          [iconDisplay]="'input'"
          [showIcon]="true"
          [timeOnly]="true"
          hourFormat="12"
          class="w-full">
          <ng-template #inputicon>
            <i class="icon-clock size-icon-sm icon-light-color"></i>
          </ng-template>
        </p-datepicker>
        @if (notificationForm.get("dueTime")?.invalid && notificationForm.get("dueTime")?.touched) {
          <small class="p-error">Schedule time is required </small>
        }
        @if (notificationForm.errors?.["pastTime"] && notificationForm.get("dueTime")?.touched) {
          <small class="p-error">Selected time must be later than the current time </small>
        }
      </div>
    </div>
  </form>
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary">
  </app-button>
  @if (!config.data?.viewOnly) {
    <app-button
      [isLoading]="loading"
      [iconStart]="loading ? 'icon-spinner-gap' : ''"
      [disabled]="!notificationForm.valid || loading || notificationForm.pristine"
      label="Schedule Notification"
      (btnClick)="confirmAction()"
      sizeClass="p-button-md"
      severity="primary">
    </app-button>
  }
</div>
